import { render, staticRenderFns } from "./print-kalog.vue?vue&type=template&id=49d83abe&scoped=true&"
import script from "./print-kalog.vue?vue&type=script&lang=js&"
export * from "./print-kalog.vue?vue&type=script&lang=js&"
import style0 from "./print-kalog.vue?vue&type=style&index=0&id=49d83abe&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "49d83abe",
  null
  
)

export default component.exports